import { ListContext } from "./chunk-QYTYTHQR.js";
import { renderIcon } from "./chunk-6KW5RJ5F.js";
import { __objRest, __spreadProps, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/elements/List/List.Item.tsx
import { forwardRef, useContext, useMemo } from "react";
import clsx from "clsx";
import { jsx, jsxs } from "react/jsx-runtime";
var DEFAULT_COMPONENT = "li";
var LIST_ITEM_CLASSNAME_MAP = {};
var ListItem = forwardRef((_a, ref) => {
  var _b = _a,
    {
      as,
      children,
      icon: iconProp,
      className
    } = _b,
    rest = __objRest(_b, ["as", "children", "icon", "className"]);
  const Component = as || DEFAULT_COMPONENT;
  const {
    variant,
    icon: listIconProp
  } = useContext(ListContext);
  const icon = useMemo(() => {
    if (iconProp) {
      return renderIcon(iconProp);
    }
    return listIconProp && renderIcon(listIconProp);
  }, [iconProp, listIconProp]);
  return /* @__PURE__ */jsxs(Component, __spreadProps(__spreadValues({
    ref,
    className: clsx("pd:list__item", className),
    role: "listitem"
  }, rest), {
    children: [variant === "icon" && /* @__PURE__ */jsx("span", {
      className: "pd:list__icon",
      children: icon
    }), children]
  }));
});
var StoryListItem = args => /* @__PURE__ */jsx(ListItem, __spreadValues({}, args));
var List_Item_default = ListItem;
export { LIST_ITEM_CLASSNAME_MAP, StoryListItem, List_Item_default };